import { Link } from '../../types/api';

export interface HiringManagerState {
    vacancy: Vacancy | undefined;
}

export interface Vacancy {
    id: string;
    name: string;
    hiringManagerVideoReference: string | null;
    applications: Application[];
    _links?: VacancyLinks;
}

export interface VacancyLinks {
    self: Link;
}

export interface ApplicationLinks {
    self: Link;
}

export interface Application {
    id: string;
    firstName: string;
    lastName: string;
    answers: ApplicationQuestionAnswer[];
    documents: Document[];
    hiringManagerNotes: string;
    applicationState: ApplicationState;
    _links?: ApplicationLinks;
}

export enum ApplicationState {
    CREATED = 'CREATED',
    INVITATION_SENT = 'INVITATION_SENT',
    APPLICATION_SUBMITTED = 'APPLICATION_SUBMITTED',
    APPLICATION_ACCEPTED = 'APPLICATION_ACCEPTED',
    APPLICATION_REJECTED = 'APPLICATION_REJECTED'
}

export interface ApplicationQuestionAnswer {
    key: string;
    question: string;
    videoId: string | undefined;
}

export interface Document {
    id: string;
    documentReference: string;
    documentName: string;
}



// WEBPACK FOOTER //
// ./src/scenes/hiring-manager/types.ts